import { Response } from '@marketplace-web/core-api/api-client-util'

import { BrandsResp, BrandModel } from '../types/brand'
import { transformBrandDto } from './brand'

export const transformBrandsResponse = (response: Response<BrandsResp>): Array<BrandModel> =>
  response.brands.map(transformBrandDto)
